/* eslint-disable complexity */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable max-lines */
import { SafetyLocalStorage } from '@mail-core/std';
import { Icon20InfoCircleOutline } from '@vkontakte/icons';
import { Headline, Paragraph, Spacing, Switch, Text } from '@vkontakte/vkui';
import theme from '@vkontakte/vkui-tokens/themes/cloud/cssVars/theme';
import classNames from 'clsx';
import star1Image from 'img/aiTariff/star1.png';
import star2Image from 'img/aiTariff/star2.png';
import familyByOptionImage from 'img/family-by-option/doc.png';
import familyByOptionWebp from 'img/family-by-option/doc.webp';
import sale80 from 'img/quota-landing/blackFriday2025/sale_large.png';
import sale81 from 'img/quota-landing/blackFriday2025/sale_large_family.png';
import family1TbImage from 'img/quota-landing/family/1Tb.png';
import family2TbImage from 'img/quota-landing/family/2Tb.png';
import family256GbImage from 'img/quota-landing/family/256Gb.png';
import family512GbImage from 'img/quota-landing/family/512Gb.png';
import familySpaceToEach1TbImage from 'img/quota-landing/family/spaceToEach/1tb.png';
import familySpaceToEach2TbImage from 'img/quota-landing/family/spaceToEach/2tb.png';
import familySpaceToEach256GbImage from 'img/quota-landing/family/spaceToEach/256gb.png';
import familySpaceToEach512GbImage from 'img/quota-landing/family/spaceToEach/512gb.png';
import familySpaceToEachMembersImage from 'img/quota-landing/family/spaceToEach/members.png';
import firstImage from 'img/quota-landing/vigbo/first.png';
import fourthImage from 'img/quota-landing/vigbo/fourth.png';
import vigboLogo from 'img/quota-landing/vigbo/logo.png';
import secondImage from 'img/quota-landing/vigbo/second.png';
import thirdImage from 'img/quota-landing/vigbo/third.png';
import React, { type VFC, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { aiTariffAbVariantC1, aiTariffAbVariantC2 } from 'reactApp/appHelpers/featuresHelpers/features/aiTariff';
import { beautifulAddressBenefit, beautifulAddressEnabled } from 'reactApp/appHelpers/featuresHelpers/features/beautifulAddress';
import { compactFirstScroll } from 'reactApp/appHelpers/featuresHelpers/features/compactFirstScroll';
import { cyberMonday2025 } from 'reactApp/appHelpers/featuresHelpers/features/cyberMonday2025';
import { TariffCardHeaderMode } from 'reactApp/appHelpers/featuresHelpers/features/disableAdsScreen';
import { isFamilySpaceExpValue } from 'reactApp/appHelpers/featuresHelpers/features/familySpaceToEach';
import {
    familyByOptionsEnterTooltipFeature,
    familyByOptionsFeature,
    multiTariffShow,
    multiTariffSpaceToEachFamilyMember,
    vigboTariffTooltipEnabled,
} from 'reactApp/appHelpers/featuresHelpers/features/multiTariff';
import { isFeatureNeurofilterPromo } from 'reactApp/appHelpers/featuresHelpers/features/neurofilter';
import {
    showEditingDocumentFeatureB,
    showEditingDocumentFeatureC,
} from 'reactApp/appHelpers/featuresHelpers/features/showEditingDocumentFeature';
import { tariffCardPersonal } from 'reactApp/appHelpers/featuresHelpers/features/tariifCardPersonal';
import { useFamilyShowFeaturesHook } from 'reactApp/hooks/useFamilyShowHook';
import type { TTimer } from 'reactApp/hooks/useLongLoad';
import { getMultiTariffActiveTab } from 'reactApp/modules/quotaLanding/quotaLanding.selector';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import { FamilyByOptionTooltip } from 'reactApp/sections/QuotaLanding/FamilyByOptionTooltip/FamilyByOptionTooltip';
import { useFamilyByOptionInfoTooltip } from 'reactApp/sections/QuotaLanding/FamilyByOptionTooltip/FamilyByOptionTooltip.hook';
import { FamilySpaceToEachTooltip } from 'reactApp/sections/QuotaLanding/FamilySpaceToEachTooltip/FamilySpaceToEachTooltip';
import {
    FAMILY_SPACE_TO_EACH_WELCOME_ITEM_ID,
    FamilySpaceToEachWelcomeTooltip,
} from 'reactApp/sections/QuotaLanding/FamilySpaceToEachWelcomeTooltip/FamilySpaceToEachWelcomeTooltip';
import { useFamilyTariffFromQuery } from 'reactApp/sections/QuotaLanding/hooks/useFamilyTariffFromQuery';
import { VIGBO_TOOLTIP_ID, VigboTooltip } from 'reactApp/sections/QuotaLanding/VigboTooltip/VigboTooltip';
import { Button } from 'reactApp/ui/Button/Button';
import { DiscountLabel } from 'reactApp/ui/DiscountLabel/DiscountLabel';
import { ETooltipPlacement } from 'reactApp/ui/FloatingTooltip/FloatingTooltip.types';
import { TariffFeatureList } from 'reactApp/ui/TariffCardNew/components/TariffFeatureList';
import { TariffLabel } from 'reactApp/ui/TariffCardNew/components/TariffLabel';
import { ETariffLabelKind, ETariffLabelRadius } from 'reactApp/ui/TariffCardNew/components/TariffLabel.types';
import { TariffSpace } from 'reactApp/ui/TariffCardNew/components/TariffSpace';
import { TariffSwitch } from 'reactApp/ui/TariffCardNew/components/TariffSwitch';
import { sendDwh } from 'reactApp/utils/ga';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';

import { ETabsName } from '../TariffSectionNew/TariffSection.constants';
import { FeatureSwitch } from './components/FeatureSwitch';
import { TariffCardImageHeader } from './components/TariffCardImageHeader/TariffCardImageHeader';
import styles from './TariffCard.css';
import { type ITariffCardProps, ETariffCardWidth, TariffCardContentSize } from './TariffCard.types';

const FAMILY_ENTER_TOOLTIP_ID = 'family-enter-tooltip';

const VIGBO_CARD_IMAGES = {
    256: {
        img: firstImage,
        class: styles.vigbo_peopleImg_256,
    },
    1: {
        img: secondImage,
        class: styles.vigbo_peopleImg_1,
    },
    2: {
        img: thirdImage,
        class: styles.vigbo_peopleImg_2,
    },
    4: {
        img: fourthImage,
        class: styles.vigbo_peopleImg_4,
    },
};
const FAMILY_CARD_IMAGES = {
    256: {
        img: family256GbImage,
        class: styles.family_CardImage_256Gb,
    },
    512: {
        img: family512GbImage,
        class: styles.family_CardImage_512Gb,
    },
    1: {
        img: family1TbImage,
        class: styles.family_CardImage_1Tb,
    },
    2: {
        img: family2TbImage,
        class: styles.family_CardImage_2Tb,
    },
};

const FAMILY_CARD_SPACE_TO_EACH_IMAGES = {
    256: {
        img: familySpaceToEach256GbImage,
        totalSpace: 1,
    },
    512: {
        img: familySpaceToEach512GbImage,
        totalSpace: 2,
    },
    1: {
        img: familySpaceToEach1TbImage,
        totalSpace: 4,
    },
    2: {
        img: familySpaceToEach2TbImage,
        totalSpace: 8,
    },
};

/* eslint-disable max-lines-per-function */
export const TariffCard: VFC<ITariffCardProps> = ({
    dataQa,
    onClick,
    width = ETariffCardWidth.w360,
    tariffId,
    space,
    showSpaceWithPlus = true,
    giftSpace,
    buttonText,
    buttonSize,
    buttonTextSize,
    headerPrimaryText,
    headerPrimaryTextCrossedOut,
    headerPrimaryTextLarge,
    headerPrimaryTextExtraLarge,
    headerPrimaryTextLight,
    buttonPrimary,
    buttonPrimaryLight,
    buttonDark,
    buttonDisabled,
    buttonAdditionalText,
    focused,
    label,
    labelKind,
    customHeader,
    customContent,
    onClickButton,
    onClickSwitch,
    switchOptions,
    switchChecked,
    featureListOptions,
    footerFeatureListOptions,
    buttonInFooter,
    compact,
    compactFeatureList = false,
    discountLabel,
    infoBlock,
    savingInButton,
    disable,
    action,
    withoutButton,
    accentFeature,
    footerText,
    onLabelClick,
    focusedWithoutShadow = false,
    accentFocused = false,
    buttonInInfoBlock = false,
    stretchInfoBlock = false,
    buttonInFooterGap = 36,
    contentSize = TariffCardContentSize.middle,
    boldSavingLabel = false,
    // tempexp_17086-next-line
    bordered = false,
    isRebrandingQuotaLanding = false,
    featuresSmallSize = false,
    isRebranding = false,
    /* tempexp_17509-next-line */
    isFromLitres = false,
    // tempexp_17371-next-line
    hideButtonInMonthTariff,
    limeSavingLabel = false,
    headerMode: providedHeaderMode = TariffCardHeaderMode.none,
    withMascot = false,
    withSpace = true,
    withInfoBlock = true,
    subscriptionPage,
    borderType,
    disableAction = false,
    newQuotaAsFeatureText,
    isFromFamilyTariff = false,
    isMayPromo2025Tariff = false,
    mayPromo2025Enabled = false,
    familyByOptionShow = false,
    familyByOptionsSwitchState = false,
    familyByOptionsHandler = () => {},
    isMonth,
    isMultiBasic,
    tariffPriceDif,
    showFamilyStartTooltip,
    compactFont,
    isFirstCard = false,
    isAiTariff = false,
    aiTariffByOptionShow = false,
    aiTariffByOptionSwitchState = false,
    aiTariffByOptionHandler,
    isVigboTariff = false,
    isFamilyTariff = false,
    isForAiTariff = false,
    blackFriday2025Enabled = false,
    isMultiAdvanced,
    isBlackFriday2025Tariff = false,
    isBlackFriday2025TariffSpaceEveryone = false,
}) => {
    let headerMode = providedHeaderMode === TariffCardHeaderMode.none ? null : providedHeaderMode;
    if (withMascot && !headerMode) {
        headerMode = TariffCardHeaderMode.mascot;
    }

    const actionEnabled = cyberMonday2025 && !disableAction;
    const email = useSelector(UserSelectors.getEmail);
    const localStorage = new SafetyLocalStorage({});

    const forceFamilyTariffFromQuery = useFamilyTariffFromQuery();

    const { setShowInfoTooltip, showInfoTooltip, infoTooltipRef } = useFamilyByOptionInfoTooltip();
    const enterTooltipRef = useRef<HTMLDivElement | null>(null);
    const familySpaceToEachRef = useRef<HTMLDivElement | null>(null);
    const vigboTooltipRef = useRef<HTMLDivElement | null>(null);
    const showVigboTooltip = vigboTariffTooltipEnabled && window.localStorage.getItem(`${email}|${VIGBO_TOOLTIP_ID}`) !== 'true';
    const [srcMedia, setSrcMedia] = useState(familyByOptionImage);
    const timerRef = useRef<TTimer>(null);
    const isOverquota = useSelector(UserQuotaSelectors.isOverquota);
    const isFamilyUser = useFamilyShowFeaturesHook();
    const activeTariffTab = useSelector(getMultiTariffActiveTab);
    /** CLOUD-4750: Исключаем пользователей из экспа */
    const familySpaceToEachCheckUser = multiTariffSpaceToEachFamilyMember && !isFamilyUser && !isOverquota;

    useEffect(() => {
        if (showFamilyStartTooltip) {
            timerRef.current = setTimeout(() => {
                sessionStorage.setItem(`${FAMILY_ENTER_TOOLTIP_ID}`, 'true');
            }, 30000);
        }
    }, [showFamilyStartTooltip]);

    const closeEnterTooltip = () => {
        sessionStorage.setItem(`${FAMILY_ENTER_TOOLTIP_ID}`, 'true');
        if (timerRef?.current) {
            clearTimeout(timerRef.current);
        }
    };

    const [showSpaceToEachTooltip, setShowSpaceToEachTooltip] = useState<boolean>(false);

    const [showSpaceToEachWelcomeTooltip, setShowSpaceToEachWelcomeTooltip] = useState<boolean>(false);
    let spaceToEachWelcomeTimeout: ReturnType<typeof setTimeout>;
    useEffect(() => {
        if (
            isFirstCard &&
            isFamilyTariff &&
            familySpaceToEachCheckUser &&
            !spaceToEachWelcomeTimeout &&
            !showSpaceToEachWelcomeTooltip &&
            localStorage.getItem(`${email}|${FAMILY_SPACE_TO_EACH_WELCOME_ITEM_ID}`) !== 'true' &&
            sessionStorage.getItem(`${FAMILY_SPACE_TO_EACH_WELCOME_ITEM_ID}-show`) === 'true'
        ) {
            spaceToEachWelcomeTimeout = setTimeout(() => {
                setShowSpaceToEachWelcomeTooltip(true);
                spaceToEachWelcomeTimeout = setTimeout(() => {
                    sendDwh({
                        eventCategory: 'tooltip',
                        action: 'close',
                        dwhData: {
                            name: 'fam_price_not_change',
                        },
                    });
                    sessionStorage.removeItem(`${FAMILY_SPACE_TO_EACH_WELCOME_ITEM_ID}-show`);
                    setShowSpaceToEachWelcomeTooltip(false);
                }, 20000);
            }, 1000);
        }
    }, [sessionStorage.getItem(`${FAMILY_SPACE_TO_EACH_WELCOME_ITEM_ID}-show`)]);

    const tariffSpace = (
        <TariffSpace
            dataQa={dataQa && 'space'}
            units={space.units}
            space={space.space}
            giftSpace={giftSpace}
            giftKind={labelKind}
            showSpaceWithPlus={showSpaceWithPlus && !isVigboTariff && !isFamilyTariff && !isForAiTariff}
            contentSize={contentSize}
            isRebrandingQuotaLanding={isRebrandingQuotaLanding}
            isRebranding={isRebranding}
            isVigboTariff={isVigboTariff}
            isFamilyTariff={isFamilyTariff}
        />
    );

    const button = useMemo(
        () =>
            !withoutButton && (
                <>
                    <div
                        className={classNames(styles.buttonWrapper, {
                            [styles.buttonWrapper_withMargin]: buttonInInfoBlock,
                            [styles.buttonWrapper_inFooter]: buttonInFooter,
                        })}
                    >
                        {discountLabel && (
                            <div className={styles.discountLabel}>
                                <DiscountLabel discount={discountLabel} />
                            </div>
                        )}
                        <Button
                            data-qa={dataQa && 'button'}
                            data-qa-primary={dataQa && buttonPrimary}
                            data-qa-disabled={dataQa && buttonDisabled}
                            fluid
                            onClick={onClickButton}
                            disabled={buttonDisabled}
                            className={classNames(styles.cardButton, {
                                [styles.cardButton_primary]: buttonPrimary,
                                [styles.cardButton_disabled]: buttonDisabled,
                                [styles.cardButton_primaryLight]: buttonPrimaryLight,
                                [styles.cardButton_dark]: buttonDark,
                                [styles[`cardButton_${buttonSize}`]]: Boolean(buttonSize),
                                [styles.cardButton_action]: action && !isRebranding,
                                [styles.cardButton_InInfoBlock]: buttonInInfoBlock,
                                [styles.cardButton_rebranding]: isRebranding,
                                [styles.cardButton_cyberMonday2025]: actionEnabled && !subscriptionPage,
                            })}
                        >
                            <span
                                data-qa={dataQa && 'buttonText'}
                                className={classNames({
                                    [styles[`buttonText_${buttonTextSize}`]]: Boolean(buttonTextSize),
                                })}
                            >
                                {buttonText}
                            </span>
                            {Boolean(buttonAdditionalText) && (
                                <div className={styles.buttonAdditionalText} data-qa={dataQa && 'buttonAdditionalText'}>
                                    {buttonAdditionalText}
                                </div>
                            )}
                        </Button>
                        {Boolean(savingInButton) &&
                            !isMayPromo2025Tariff &&
                            !isBlackFriday2025Tariff &&
                            !isBlackFriday2025TariffSpaceEveryone && (
                                <div
                                    className={classNames(styles.saving, {
                                        [styles.boldSavingLabel]: boldSavingLabel,
                                        [styles.limeSavingLabel]: limeSavingLabel,
                                    })}
                                >
                                    -{savingInButton}%
                                </div>
                            )}
                        {Boolean(savingInButton) && isBlackFriday2025Tariff && (
                            <img
                                alt="-80%"
                                src={sale80}
                                className={classNames(styles.savingBF, {
                                    [styles.hideImg]:
                                        (isFamilySpaceExpValue || multiTariffSpaceToEachFamilyMember) &&
                                        activeTariffTab === ETabsName.family,
                                })}
                            />
                        )}
                        {Boolean(savingInButton) && isBlackFriday2025TariffSpaceEveryone && (
                            <img
                                alt="-81%"
                                src={sale81}
                                className={classNames(styles.savingBF, {
                                    [styles.hideImg]:
                                        activeTariffTab !== ETabsName.family ||
                                        !(isFamilySpaceExpValue || multiTariffSpaceToEachFamilyMember),
                                })}
                            />
                        )}
                    </div>
                </>
            ),
        [
            action,
            buttonAdditionalText,
            buttonDisabled,
            buttonPrimary,
            buttonPrimaryLight,
            buttonSize,
            buttonText,
            buttonTextSize,
            dataQa,
            discountLabel,
            onClickButton,
            savingInButton,
            withoutButton,
            buttonInFooter,
        ]
    );
    const darkTheme = isDarkThemeModeEnabled();

    const featureListOptionsBlock = useMemo(() => {
        if (!featureListOptions) {
            return null;
        }
        const items = [...featureListOptions];
        if (showEditingDocumentFeatureC) {
            items.splice(1, 0, {
                text: newQuotaAsFeatureText,
                key: 'newQuotaAsFeatureText',
            });
        }

        if (beautifulAddressEnabled && !multiTariffShow) {
            if (!isFromFamilyTariff) {
                items[1] = items[2];
                items[2] = { text: 'Загрузка файлов до 100 ГБ', key: 'upload' };
            }
            items[3] = {
                text: beautifulAddressBenefit,
                key: 'beautiful',
                disabled: isFromFamilyTariff || isMonth,
            };
        }

        // tempexp_19645-start
        if (isAiTariff) {
            items[0].forcePrimaryColor = true;
            items[0].primaryColor = true;
        }
        // tempexp_19645-end

        if (isFeatureNeurofilterPromo && items[1]?.key === 'duplicates' && !isAiTariff && !aiTariffAbVariantC1 && !aiTariffAbVariantC2) {
            items[1].text = 'Нейропомощник в Почте';
            items[1].key = 'neuroassistant';
        }

        return (
            <div
                className={classNames(styles.featureList, {
                    [styles.featureList_white]: compact && !disable,
                    [styles.featureList_rebrandingQuotaLanding]: isRebrandingQuotaLanding,
                    [styles.featureList_familyByOptions]: familyByOptionsFeature && isRebrandingQuotaLanding,
                    [styles.featuresList_vigbo]: isVigboTariff,
                    [styles.featuresList_family]: isFamilyTariff,
                    [styles.featuresList_familySpaceToEach]: isFamilyTariff && familySpaceToEachCheckUser,
                })}
            >
                <TariffFeatureList
                    accent={accentFeature}
                    dataQa={dataQa && 'featureList'}
                    showIcon
                    items={items}
                    contentSize={compactFeatureList ? TariffCardContentSize.compact : contentSize}
                    isRebrandingQuotaLanding={isRebrandingQuotaLanding}
                    featuresSmallSize={featuresSmallSize}
                    isRebranding={isRebranding}
                    forceFamilyTariff={forceFamilyTariffFromQuery}
                    isMultiBasic={isMultiBasic}
                    isMultiAdvanced={isMultiAdvanced}
                    isVigboTariff={isVigboTariff}
                    isFamilyTariff={isFamilyTariff}
                    blackFriday2025Enabled={blackFriday2025Enabled}
                />
            </div>
        );
    }, [isMonth, forceFamilyTariffFromQuery, compactFeatureList, accentFeature]);

    return (
        <div
            data-qa={dataQa}
            data-qa-focused={dataQa && focused}
            data-qa-tariffid={dataQa && tariffId}
            data-tariff-card={true}
            className={classNames(styles.card, {
                [styles[`contentSize_${contentSize}`]]: contentSize,
                [styles.card_bordered]: bordered,
                [styles.card_focused]: focused || isAiTariff,
                [styles.custom_focused_border]: customContent || customHeader,
                [styles.card_vigbo]: isVigboTariff,
                [styles.card_family]: isFamilyTariff,
                [styles.focused_without_shadow]: focusedWithoutShadow,
                [styles.accentFocused]: accentFocused,
                [styles.card_compact]: compact || compactFirstScroll,
                [styles.card_compact_padding]: compactFeatureList,
                [styles.card_disable]: disable,
                [styles.card_action]: action,
                [styles[`card_${width}`]]: width,
                [styles.darkMode]: darkTheme,
                [styles.card_rebrandingQuotaLanding]: isRebrandingQuotaLanding,
                [styles.card_rebranding]: isRebranding,
                [styles.card_imageHeader]: !!headerMode,
                [styles.card_compactScroll]: compactFirstScroll && isRebrandingQuotaLanding,
                [styles.card_cyberMonday2025]: actionEnabled && !subscriptionPage,
                [styles[`border_type_${borderType}`]]: Boolean(borderType),
                // tempexp_18085-next-line
                [styles.card_personal]: tariffCardPersonal === 'c' && isRebrandingQuotaLanding,
                [styles.card_showEditingDocumentFeatureB]: showEditingDocumentFeatureB,
                [styles.card_showEditingDocumentFeatureC]: showEditingDocumentFeatureC,
                [styles.card_compactFont]: compactFont,
                [styles.card_aiTariff]: isAiTariff,
                [styles.card_aiTariffNew]: isForAiTariff,
                [styles.customHeader]: !!customHeader,
                [styles.card_blackFriday2025]: isBlackFriday2025Tariff,
            })}
            onClick={onClick}
        >
            {showSpaceToEachWelcomeTooltip && <div className={styles.spaceToEachTooltip_background} />}
            {!!headerMode && <TariffCardImageHeader headerMode={headerMode} />}
            {label && (
                <TariffLabel
                    onClick={onLabelClick && (() => onLabelClick(true))}
                    className={styles.label}
                    disableAction={disableAction}
                    dataQa={dataQa && 'label'}
                    contentSize={contentSize}
                    radius={
                        /* tempexp_17509-start */
                        !isFromLitres ||
                        /* tempexp_17509-end */
                        focused
                            ? ETariffLabelRadius.r22
                            : ETariffLabelRadius.r24
                    }
                    kind={
                        /* tempexp_18094-next-line */
                        !tariffCardPersonal &&
                        /* tempexp_17509-start */
                        !isFromLitres &&
                        /* tempexp_17509-end */
                        focused &&
                        action &&
                        /* tempexp_18086-next-line */
                        labelKind !== ETariffLabelKind.referral &&
                        labelKind !== ETariffLabelKind.tariffPromo &&
                        labelKind !== ETariffLabelKind.tarrifRebranding &&
                        labelKind !== ETariffLabelKind.unlimitedAutoupload
                            ? ETariffLabelKind.actionBlack
                            : labelKind
                    }
                    isRebrandingQuotaLanding={isRebrandingQuotaLanding}
                    enableTopRightBorder={isRebrandingQuotaLanding && focused && !actionEnabled}
                    subscriptionPage={subscriptionPage}
                    isFromFamilyTariff={isFromFamilyTariff}
                    mayPromo2025Enabled={mayPromo2025Enabled}
                    blackFriday2025Enabled={blackFriday2025Enabled}
                    isMultiAdvanced={isMultiAdvanced}
                >
                    {label}
                </TariffLabel>
            )}
            {customHeader ? (
                customHeader({
                    spaceNode: tariffSpace,
                    infoBlockNode: infoBlock,
                    featuresNode: featureListOptionsBlock,
                    buttonNode: button,
                    space: space.space,
                })
            ) : (
                <div
                    className={classNames(styles.cardHeader, {
                        [styles.cardHeader_stretch]: stretchInfoBlock,
                        [styles.cardHeader_vigbo]: isVigboTariff,
                        [styles.cardHeader_family]: isFamilyTariff,
                    })}
                >
                    {isFamilyTariff && !familySpaceToEachCheckUser && (
                        <>
                            <Text className={styles.family_tag}>Для семьи</Text>
                            <img
                                src={FAMILY_CARD_IMAGES[space.space].img}
                                className={classNames(styles.family_CardImage, FAMILY_CARD_IMAGES[space.space]?.class)}
                                alt="Семейный тариф"
                            />
                            <div className={styles.family_header} />
                        </>
                    )}
                    {isVigboTariff && (
                        <>
                            <div ref={vigboTooltipRef} className={styles.vigbo_logo}>
                                <img src={vigboLogo} />
                            </div>
                            <img
                                src={VIGBO_CARD_IMAGES[space.space].img}
                                className={classNames(styles.vigbo_peopleImg, VIGBO_CARD_IMAGES[space.space].class)}
                            />
                            <div className={styles.vigbo_header} />
                            {isFirstCard && showVigboTooltip && <VigboTooltip ref={vigboTooltipRef} />}
                        </>
                    )}
                    {isFromFamilyTariff && !mayPromo2025Enabled && (
                        <>
                            <div className={styles.family_img_back} />
                            <div className={styles.family_img} />
                            <div className={styles.child_img} />
                        </>
                    )}
                    {withSpace && tariffSpace}
                    {isFamilyTariff && familySpaceToEachCheckUser && (
                        <>
                            <div
                                className={classNames(styles.familySpaceToEach_tag, {
                                    [styles.familySpaceToEach_tag_focus]: focused,
                                })}
                            >
                                <Text weight="2">Каждому</Text>
                            </div>
                            <img
                                src={FAMILY_CARD_SPACE_TO_EACH_IMAGES[space.space].img}
                                className={classNames(styles.familySpaceToEach_CardImage)}
                                alt="Семейный тариф"
                            />
                            <div className={styles.familySpaceToEach_header} />
                            <div
                                className={styles.familySpaceToEach_root}
                                ref={familySpaceToEachRef}
                                onClick={() => !showSpaceToEachTooltip && setShowSpaceToEachTooltip(true)}
                            >
                                <Headline level="1" weight="2" className={styles.familySpaceToEach_headline}>
                                    Добавьте ещё 3 близких
                                </Headline>
                                <Paragraph className={styles.familySpaceToEach_paragraph}>
                                    будет до {FAMILY_CARD_SPACE_TO_EACH_IMAGES[space.space].totalSpace} ТБ на семью
                                </Paragraph>
                                <img src={familySpaceToEachMembersImage} alt="Место каждому" className={styles.familySpaceToEach_image} />
                            </div>
                            {showSpaceToEachTooltip && (
                                <FamilySpaceToEachTooltip
                                    ref={familySpaceToEachRef}
                                    setShowTooltip={setShowSpaceToEachTooltip}
                                    onButtonClick={onClickButton}
                                />
                            )}
                            {showSpaceToEachWelcomeTooltip && (
                                <FamilySpaceToEachWelcomeTooltip
                                    ref={familySpaceToEachRef}
                                    setShowTooltip={setShowSpaceToEachWelcomeTooltip}
                                />
                            )}
                        </>
                    )}
                    {headerPrimaryText && (
                        <div
                            data-qa={dataQa && 'headerPrimaryText'}
                            data-qa-crossedout={dataQa && headerPrimaryTextCrossedOut}
                            data-qa-large={dataQa && headerPrimaryTextLarge}
                            className={classNames(styles.cardHeaderPrimaryText, {
                                [styles.cardHeaderPrimaryText_crossedOut]: headerPrimaryTextCrossedOut,
                                [styles.cardHeaderPrimaryText_large]: headerPrimaryTextLarge,
                                [styles.cardHeaderPrimaryText_extra]: headerPrimaryTextExtraLarge || !!headerMode,
                                [styles.cardHeaderPrimaryText_light]: headerPrimaryTextLight,
                                [styles.cardHeaderPrimaryText_nomargin]: !!headerMode,
                                [styles.cardHeaderPrimaryText_marginTop]: labelKind === ETariffLabelKind.bottomCenter,
                            })}
                        >
                            {headerPrimaryText}
                        </div>
                    )}
                    {withInfoBlock && !showEditingDocumentFeatureC && (buttonInInfoBlock ? button : infoBlock)}
                    {switchOptions && (
                        <div className={styles.switch}>
                            <TariffSwitch
                                dataQa={dataQa && 'tariffSwitch'}
                                checked={switchChecked}
                                name={`tariff_${tariffId}`}
                                onClick={onClickSwitch}
                                options={switchOptions}
                                isRebranding={isRebranding}
                            />
                        </div>
                    )}
                </div>
            )}
            {customContent ? (
                customContent({
                    featuresNode: featureListOptionsBlock,
                    buttonNode: button,
                    spaceNode: tariffSpace,
                    infoBlockNode: infoBlock,
                })
            ) : (
                <>
                    {!buttonInFooter && !buttonInInfoBlock && button}
                    {!showEditingDocumentFeatureC && featureListOptionsBlock}
                    {footerFeatureListOptions && (
                        <>
                            <div className={styles.delimiter} data-qa={dataQa && 'featureDelimiter'} />
                            <div className={styles.featureList}>
                                <TariffFeatureList
                                    accent={accentFeature}
                                    dataQa={dataQa && 'footerFeatureList'}
                                    showIcon
                                    contentSize={contentSize}
                                    items={footerFeatureListOptions}
                                    isRebranding={isRebranding}
                                    forceFamilyTariff={forceFamilyTariffFromQuery}
                                    isFamilyTariff={isFamilyTariff}
                                    blackFriday2025Enabled={blackFriday2025Enabled}
                                    isMultiAdvanced={isMultiAdvanced}
                                />
                            </div>
                        </>
                    )}
                    {isAiTariff && (
                        <div className={styles.aiTariffImg}>
                            <img src={star1Image} className={styles.star1} />
                            <img src={star2Image} className={styles.star2} />
                        </div>
                    )}
                    {footerText && <div className={styles.footerText}>{footerText}</div>}
                    {familyByOptionShow && (
                        <>
                            {familyByOptionsEnterTooltipFeature &&
                                focused &&
                                !sessionStorage.getItem(`${FAMILY_ENTER_TOOLTIP_ID}`) &&
                                showFamilyStartTooltip && (
                                    <FamilyByOptionTooltip
                                        leftOffset={124}
                                        ref={enterTooltipRef}
                                        onClose={closeEnterTooltip}
                                        closeOnOutsideClick={false}
                                    />
                                )}
                            {showInfoTooltip && (
                                <FamilyByOptionTooltip
                                    ref={infoTooltipRef}
                                    onClose={setShowInfoTooltip}
                                    placement={isFirstCard ? ETooltipPlacement.top : ETooltipPlacement.topEnd}
                                />
                            )}
                            <div
                                className={styles.familyByOptions}
                                onPointerEnter={() => setSrcMedia(familyByOptionWebp)}
                                onPointerLeave={() => setSrcMedia(familyByOptionImage)}
                                ref={enterTooltipRef}
                            >
                                <img src={srcMedia} alt="Семья" className={styles.familyByOptionsMedia} />
                                <span className={styles.familyByOptionsText}>
                                    Функции для семьи
                                    <div
                                        ref={infoTooltipRef}
                                        className={classNames(styles.familyByOptionsIcon, {
                                            [styles.familyByOptionsIconShow]: showInfoTooltip,
                                        })}
                                    >
                                        <Icon20InfoCircleOutline
                                            fill={theme.colorIconPrimary.normal.value}
                                            width={20}
                                            height={20}
                                            onClick={() => {
                                                closeEnterTooltip();
                                                setSrcMedia(familyByOptionImage);
                                                setShowInfoTooltip(!showInfoTooltip);
                                            }}
                                        />
                                    </div>
                                </span>
                                <span
                                    className={classNames(styles.familyByOptionsAdditionalText, {
                                        [styles.familyByOptionsAdditionalTextChecked]: familyByOptionsSwitchState,
                                    })}
                                >
                                    {familyByOptionsSwitchState ? `${tariffPriceDif} ₽ в месяц` : `ещё +${tariffPriceDif} ₽ в месяц`}
                                </span>
                                <Switch name="family-by-options" checked={familyByOptionsSwitchState} onChange={familyByOptionsHandler} />
                            </div>
                        </>
                    )}
                    {aiTariffByOptionShow && (
                        <FeatureSwitch switchOn={aiTariffByOptionSwitchState} onChanged={aiTariffByOptionHandler} disabled={isMultiBasic} />
                    )}
                    {buttonInFooter && (
                        <>
                            <Spacing size={buttonInFooterGap} />
                            {hideButtonInMonthTariff ? (
                                <div
                                    className={classNames(styles.onlyYearTariffWrapper, {
                                        [styles.onlyYearTariffWrapperRebranding]: isRebrandingQuotaLanding,
                                        [styles.onlyYearTariffPersonal]: tariffCardPersonal === 'b' || tariffCardPersonal === 'c',
                                    })}
                                >
                                    <Headline weight="2" className={styles.onlyYearText}>
                                        Доступен в годовом плане
                                    </Headline>
                                </div>
                            ) : (
                                button
                            )}
                        </>
                    )}
                    {showEditingDocumentFeatureC && featureListOptionsBlock}
                    {/* tempexp_16800-end */}
                    {buttonInInfoBlock && !buttonInFooter && <Spacing size={26} />}
                    {/* tempexp_16800-end */}
                </>
            )}
        </div>
    );
};
